import type { HelpFile } from '../../types/help'
import { ConnectorAttributesTabTestIds } from '../../../testids/ConnectorAttributesTabTestIds'

export const connectorAttributesTabHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [ConnectorAttributesTabTestIds.cardTitleConnectorAttributes]: 'Attribute mappings for this connector — how identity attributes translate into target-system fields during provisioning.',
  },
}
